import { Pipe, PipeTransform } from '@angular/core';

/**
 * MemoizePipe. This pipe can be used to memoize stateless functions. This way, staless funtions with big computation
 * requirements, only need to be executed when input parameters change, instean when change detection is being trigered.
 * @example
 * @Component({
  selector: 'app-root',
  template:  `
    {{ counter | memoize: showResult}}
  `,
  })
  export class CounterComponent implements OnInit {
    counter = 0;
    
    ngOnInit() {
      setInterval(() => {
        this.counter++;
        this.showResult(this.counter);
      }, 5000)
    }

    showResult(value) { return 'The value is: ' + value; }
  }
 */
@Pipe({ name: 'memoize', standalone: true, pure: true })
export class MemoizePipe implements PipeTransform {
  transform(firstArgument: any, fn: Function, ...args: any[]): any {
    return fn(firstArgument, ...args);
  }
}
